/**
 * ReviewsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import SupportTicketContext from './support-ticket-context'
import { createSupportTicket } from './support-ticket-api'

export default function ReviewsProvider({ children }) {
  const state = {
    createSupportTicket,
  }
  return (
    <SupportTicketContext.Provider value={state}>
      {children}
    </SupportTicketContext.Provider>
  )
}
